import ListProcesses from "@/views/customer/quality_control/query_container/ListProcesses.vue";
import ListContainers from "@/views/customer/quality_control/query_container/ListContainers.vue";
import ListTemplates from "@/views/customer/quality_control/query_container/ListTemplates.vue";
import ListQualityInspects from "@/views/customer/quality_control/query_container/ListQualityInspects.vue";
import ShowQualityInspect from "@/views/customer/quality_control/query_container/ShowQualityInspect.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "cus",
  role: "quality_control",
  permission: "query_container",
});

export default [
  {
    path: "/cus/:customer_id/quality_control/query_container/list_processes",
    name: routeName(""),
    component: ListProcesses,
    props: true,
    meta: META
  },
  {
    path: "/cus/:customer_id/quality_control/query_container/list_containers/:agro_exporter_process_id",
    name: routeName("list_containers"),
    component: ListContainers,
    props: true,
    meta: META
  },
  {
    path: "/cus/:customer_id/quality_control/query_container/list_templates/:agro_exporter_process_id/:container_id",
    name: routeName("list_templates"),
    component: ListTemplates,
    props: true,
    meta: META
  },
  {
    path: "/cus/:customer_id/quality_control/query_container/list_quality_inspects/:agro_exporter_process_id/:container_id/:quality_template_id",
    name: routeName("list_quality_inspects"),
    component: ListQualityInspects,
    props: true,
    meta: META
  },
  {
    path: "/cus/:customer_id/quality_control/query_container/show_quality_inspect/:agro_exporter_process_id/:container_id/:quality_template_id/:quality_inspect_id",
    name: routeName("show_quality_inspect"),
    component: ShowQualityInspect,
    props: true,
    meta: META
  }
];
